/* @flow */

export default class PaymentDetail {
  amount: number;
  type: number;
  translationKey: string;
}
